import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
  },
  subTitle: {
    fontWeight: 500,
  },
  tooltip: {
    backgroundColor: "#FFFFFF",
    opacity: "1!important",
    color: "#000000",
    minWidth: 160,
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
    fontSize: theme.typography.pxToRem(14),
    borderRadius: theme.spacing(2),
    boxShadow: "0px 4px 40px rgba(106, 103, 103, 0.12)",
  },
  tooltipLabel: {
    color: "#929FAD",
    paddingTop: theme.spacing(0.5),
  },
}));

export default useStyles;
